import { gql } from 'graphql-tag';

export const GET_TEAMS = gql`
  query Id05c84b24c2e2d31202ed49c803008c7b(
    $companyId: ID!
    $filter: TeamFilter
    $first: Int
  ) {
    __typename
  }
`;
